import { BudgetOnboardingModalContent } from '@/components/cashflow/budget/BudgetOnboardingModalContent';
import { Button, TrackClickEventProps } from '@/components/common/Button';
import { FlexRow } from '@/components/common/Flex';
import { ArrowLeft } from '@/components/common/icons';
import { Box, Spacer } from '@chakra-ui/react';
import { useBudgetOnboardingContext } from './BudgetOnboardingContext';

interface BudgetOnboardingLayoutProps extends TrackClickEventProps {
    children: React.ReactNode;
    onContinue: VoidFunction;
    isContinueDisabled: boolean;
    isSubmitting: boolean;
    buttonText: string;
}

export const BudgetOnboardingLayout = ({
    children,
    onContinue,
    isContinueDisabled,
    isSubmitting,
    buttonText,
    onClickEvent,
    onClickEventParams,
}: BudgetOnboardingLayoutProps) => {
    const { currentStep, goToPreviousStep, variant } =
        useBudgetOnboardingContext();

    const hideBackButton =
        currentStep === 'link-accounts' || variant === 'update';

    return (
        <Box overflowY="scroll" borderRadius={6}>
            <BudgetOnboardingModalContent>
                {children}
            </BudgetOnboardingModalContent>

            <FlexRow
                bottom={0}
                py={4}
                bg="white"
                zIndex="sticky"
                position="sticky"
                borderTopWidth={1}
                align="center"
                px={8}
                justify="space-between"
            >
                {hideBackButton ? (
                    <Spacer />
                ) : (
                    <Button
                        variant="ghost"
                        colorScheme="gray"
                        h={10}
                        px={5}
                        onClick={goToPreviousStep}
                        onClickEvent="Budget Onboarding Back Button Clicked"
                        onClickEventParams={{ step: currentStep }}
                    >
                        <ArrowLeft size="sm" mr={2} />
                        Back
                    </Button>
                )}

                <Button
                    onClick={onContinue}
                    onClickEvent={onClickEvent}
                    onClickEventParams={onClickEventParams}
                    isDisabled={isContinueDisabled}
                    isLoading={isSubmitting}
                    h={12}
                >
                    {buttonText}
                </Button>
            </FlexRow>
        </Box>
    );
};
